import React from 'react';
import { Typography } from 'antd';
import { resolveGround, resolveInk } from '../../vendor/skargard/engine/color';
import ValleySpirit from './ValleySpirit';

const { Text } = Typography;

// Full-bleed stage for the vendored skargard engine.
//
// The canvas sizes itself to its parent (Visualization sets width/height 100%),
// and use_engine observes it with a ResizeObserver — so the only job here is to
// give it a box with a real height. 100dvh rather than 100vh so the mobile
// address bar does not crop the frame.
//
// No <Layout> wrapper: the piece is the page. The nav chrome would fight the
// persistence wash, which repaints the whole frame at alpha 1 - persistence.
export default function TestVizPage() {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100dvh',
        overflow: 'hidden',
        // The piece states its own ground; ask the engine for it so the
        // fill before the first frame matches the first frame.
        background: resolveGround(ValleySpirit.piece.frame, 'var(--art-paper)'),
      }}
    >
      <ValleySpirit />
      <Text
        style={{
          position: 'absolute',
          left: 16,
          bottom: 16,
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--fs-xs)',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          // Same reason as the ground: the piece states its own ink, and
          // --art-ink would be near-black over this piece's black ground.
          color: resolveInk(ValleySpirit.piece.layers[0].ink, 'var(--art-ink)'),
          opacity: 0.45,
          pointerEvents: 'none',
        }}
      >
        Valley Spirit — column variant
      </Text>
    </div>
  );
}
